import React from 'react';

/** Estrela do cabeçalho de "O que você deseja fazer hoje?" (decorativa). */
export const StarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M12 2.6l2.6 6.1 6.6.6c.5 0 .7.7.3 1l-5 4.3 1.5 6.5c.1.5-.4.9-.9.6L12 18.3l-5.1 3.4c-.4.3-1-.1-.9-.6l1.5-6.5-5-4.3c-.4-.3-.2-1 .3-1l6.6-.6L12 2.6z" />
  </svg>
);

export default StarIcon;
